var _path, _line, _line2, _path2, _path3, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftTurn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 267,
    viewBox: "0 0 299 267",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.5 267C129.867 267 110.427 263.547 92.2888 256.838C74.1507 250.129 57.6699 240.295 43.7875 227.899C29.9052 215.502 18.8931 200.785 11.38 184.588C3.86693 168.391 -8.58169e-07 151.031 0 133.5C8.58169e-07 115.969 3.86693 98.6087 11.38 82.4118C18.8931 66.2148 29.9052 51.4979 43.7875 39.1012C57.6699 26.7046 74.1507 16.8711 92.2888 10.1621C110.427 3.45308 129.867 -1.53265e-06 149.5 0L149.5 66.75C139.684 66.75 129.964 68.4765 120.894 71.831C111.825 75.1855 103.585 80.1023 96.6438 86.3006C89.7026 92.4989 84.1965 99.8574 80.44 107.956C76.6835 116.054 74.75 124.734 74.75 133.5C74.75 142.266 76.6835 150.946 80.44 159.044C84.1965 167.143 89.7026 174.501 96.6438 180.699C103.585 186.898 111.825 191.814 120.894 195.169C129.964 198.523 139.684 200.25 149.5 200.25V267Z",
    fill: "#222020"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 135,
    y1: 31.5,
    x2: 188,
    y2: 31.5,
    stroke: "white",
    strokeWidth: 5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 135,
    y1: 231.5,
    x2: 188,
    y2: 231.5,
    stroke: "white",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4203 45.7361C93.4203 45.7361 76.8521 51.2064 68.4993 58.1734C60.5403 64.8118 52.344 79.2285 52.344 79.2285",
    stroke: "white",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4203 222.494C93.4203 222.494 76.8521 217.024 68.4993 210.057C60.5403 203.419 52.344 189.002 52.344 189.002",
    stroke: "white",
    strokeWidth: 5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -2.5,
    x2: 53,
    y2: -2.5,
    transform: "matrix(0 -1 -1 0 39 160.674)",
    stroke: "white",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftTurn);
export default __webpack_public_path__ + "static/media/left-turn.a90473d84296c884e5ba38f4d47fce16.svg";
export { ForwardRef as ReactComponent };